import m, {Vnode} from "mithril";
import Page from "../Page";
import ICustomFormSettings from "../../ICustomFormSettings";
import PageZeroRowFactory from "./PageZeroRowFactory";

export default class PageZero extends Page {

    private readonly rows: any[] = [];

    public constructor(
        protected settings: ICustomFormSettings
    ) {
        super(settings);

        const factory = new PageZeroRowFactory();
        this.settings.form.grid?.layout.forEach(row => this.rows.push(factory.createRow(row)));

    }

    public rewriteFormControls(): boolean {
        const form = this.settings.form;
        return Boolean(form.aux2 || form.aux3);
    }

    private viewContent(): Vnode[] {
        return this.rows.map( row => {
            return m('.row', {}, [
                row[0] ? m('.bullet', {}, m(row[0])) : null,
                m(row[1]),
            ]);
        });
    }

	/**
	 * Conditional Hard screenout questionary
	 */
	private createPreviousButtonCallback(): undefined|(()=>void) {
		const form = this.settings.form;
		if (!form.aux2) {
			return undefined;
		}
		return () => {
			form.questionary.end("HARDSCREENOUT");
			form.questionary.save();
		};
	}

	private createViewOfPreviousButton(): Vnode|null {
		const form = this.settings.form;

		if (form.aux2 || this.settings.app.prevEnabled()) {
			return this.controls.viewPreviousButton(
				form.aux2 ?? undefined,
				this.createPreviousButtonCallback(),
			)
		}

		return null;
	}

	protected viewControls(): Vnode {
		const form = this.settings.form;
		if (this.rewriteFormControls()) {

			return m(".controls", {},
				m(".control-group", {}, [
					this.createViewOfPreviousButton(),
					this.settings.app.langSwitcherEnabled() ? this.controls.viewLanguageButton() : null,
					this.settings.app.nextEnabled() ? this.controls.viewNextButton(form.aux1 ?? undefined) : null,
				])
			);
		}
		return super.viewControls(form.aux1 || undefined);
	}

    public view(): Vnode {
		return m(".customForm.customForm-Page-zero-container", {}, [
			m(this.settings.app.header),
			m("div", {
				"class": this.settings.formHtmlClass(),
			}, [
				m(".content", {}, [this.viewContent()]),
				this.viewControls()
			]),

		]);
    }
}
